var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main",style:({ minHeight: _vm.mainHeight + 'px' })},[_c('section',{staticClass:"main-wrap"},[_c('breadcrumb',{staticClass:"breadcrumb-container"}),_vm._v(" "),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.cacheviews}},[_c('router-view',{key:_vm.key})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }